export default __webpack_public_path__ + "img/9940a04ddf1854c5dbe870d3735cf68a.svg";